export class FormController {
    constructor(host) {
        (this.host = host).addController(this);
    }
    hostConnected() {
        this.findRootForm();
    }
    /**
     * If form attribute present on cat-element we will use that attribute value to query element from document
      or query closest ancestor Element
     */
    findRootForm() {
        const host = this.host;
        const formId = host.getAttribute('form') || host?._form;
        this.form = (formId ? document.getElementById(formId) : host.closest('form'));
    }
    submit(type, submitter) {
        /**
         * When a button is placed outside a form element,
         * the 'form' property is not automatically set during the 'hostConnected' lifecycle.
         * Therefore, added this logic to handle that scenario
         */
        if (this.host?._form && !this.form) {
            this.findRootForm();
        }
        if (this.form) {
            switch (type) {
                case 'reset':
                    this.form.reset();
                    break;
                case 'submit':
                    if (submitter) {
                        submitter.hidden = true;
                        this.form.appendChild(submitter);
                    }
                    this.form.requestSubmit(submitter);
                    submitter?.remove();
                    break;
            }
        }
    }
}
